import Navbar from "@/components/feature/Navbar";
import Footer from "@/components/feature/Footer";
import usePageMeta from "@/hooks/usePageMeta";
import { faqs, topics } from "@/mocks/topics";
import Ticker from "./components/Ticker";
import Hero from "./components/Hero";
import HotBoard from "./components/HotBoard";
import LatestGrid from "./components/LatestGrid";
import CategoryGrid from "./components/CategoryGrid";
import FaqSection from "./components/FaqSection";
import BrandSection from "./components/BrandSection";

export default function Home() {
  usePageMeta({
    title: "网红大瓜 · 多方说法与当事人回应对比聚合站",
    description:
      "吃瓜观测站集中汇总网红大瓜多方爆料、当事人回应与对质现场，把各方说法放在同一版面对比，帮你看清谁在含糊、谁在转移话题。覆盖带货风波、直播争议、人设崩塌等热门事件。",
    keywords: "网红大瓜,网红大瓜多方爆料,网红大瓜当事人回应,网红大瓜各方说法,网红大瓜对质现场",
    canonical: "https://ytrongxiang.cn/",
    jsonLd: [
      {
        "@context": "https://schema.org",
        "@type": "WebSite",
        name: "吃瓜观测站",
        url: "https://ytrongxiang.cn/",
        description: "网红大瓜多方说法与当事人回应的对比聚合站",
        inLanguage: "zh-CN",
        potentialAction: {
          "@type": "SearchAction",
          target: "https://ytrongxiang.cn/list?q={search_term_string}",
          "query-input": "required name=search_term_string",
        },
      },
      {
        "@context": "https://schema.org",
        "@type": "ItemList",
        name: "热门网红大瓜事件",
        itemListElement: topics.map((t, i) => ({
          "@type": "ListItem",
          position: i + 1,
          name: t.title,
          url: `https://ytrongxiang.cn/topic/${t.id}`,
        })),
      },
      {
        "@context": "https://schema.org",
        "@type": "FAQPage",
        mainEntity: faqs.map((f) => ({
          "@type": "Question",
          name: f.q,
          acceptedAnswer: { "@type": "Answer", text: f.a },
        })),
      },
    ],
  });

  return (
    <div className="flex min-h-screen w-full flex-col bg-background-50">
      <Navbar />
      <main className="flex-1">
        <Ticker />
        <Hero />
        <HotBoard />
        <LatestGrid />
        <CategoryGrid />
        <FaqSection />
        <BrandSection />
      </main>
      <Footer />
    </div>
  );
}